import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProfileCompletionAlert } from './ProfileCompletionAlert';
import { useAuthContext } from '@asgardeo/auth-react';
import { UserService } from '../types/services/UserService';

interface RouteWithProfileCheckProps {
    children: React.ReactNode;
}

const RouteWithProfileCheck: React.FC<RouteWithProfileCheckProps> = ({ children }) => {
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [userId, setUserId] = useState<string>('anonymous');
    const navigate = useNavigate();
    const location = useLocation();
    const { getBasicUserInfo } = useAuthContext();

    // Routes that require profile check
    const routesToCheck = [
        '/packages/',
        '/consolidate',
        '/shipments',
        '/shipments/new'
    ];

    useEffect(() => {
        // Check if current path matches any of the routes to check
        const shouldCheck = routesToCheck.some(route =>
            location.pathname.startsWith(route) || location.pathname === route
        );

        if (shouldCheck) {
            checkProfileCompleteness();
        }
    }, [location.pathname]);

    const checkProfileCompleteness = async () => {
        try {
            const basicUserDetails = await getBasicUserInfo();

            if (!basicUserDetails || !basicUserDetails.sub) {
                return;
            }

            const currentUserId = basicUserDetails.sub;
            setUserId(currentUserId);

            const userInfo: any = await UserService.getUserById(currentUserId);

            if (!userInfo) {
                return;
            }

            const missing: string[] = [];

            if (!userInfo.first_name) missing.push('First Name');
            if (!userInfo.last_name) missing.push('Last Name');
            if (!userInfo.tel) missing.push('Phone Number');
            if (!userInfo.email) missing.push('Email');
            if (!userInfo.address || userInfo.address.length === 0) missing.push('Address');
            if (!userInfo.company_name) missing.push('Company Name');

            setMissingFields(missing);
        } catch (error) {
        }
    };

    const handleCompleteProfile = () => {
        // Navigate to profile settings page
        navigate('/profile');
    };

    return (
        <>
            {children}
            {missingFields.length > 0 && (
                <ProfileCompletionAlert
                    missingFields={missingFields}
                    onCompleteClick={handleCompleteProfile}
                    userId={userId}
                />
            )}
        </>
    );
};

export default RouteWithProfileCheck;
